import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, Label, Textarea } from "flowbite-react";
import { useForm } from "react-hook-form";
import { adCampaignSchema } from "../schemas/ad.campaign.schema";
import useAdCampaign from "../hooks/useAdCampaign";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { AdCampaignType } from "../types/ads.campaign";

const AdsCampaignPage = () => {
    const { loading, error, campaign, loadAdCampaign, saveAdCampaign } = useAdCampaign();

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(adCampaignSchema),
    });

    const save = async (data: any) => {
        if (!data.code || !campaign?.id) return;
        const item: AdCampaignType = {
            id: campaign?.id || 0,
            code: data.code,
        } 
        const saved = await saveAdCampaign(item);

        toast(saved ? "Campaña guardada correctamente" : "Error al guardar campaña", {
            type: saved ? "success" : "error",
            autoClose: 2000,
        });
    }

    useEffect(() => {
        if (!error) return;
        toast(error, {
            type:  "error",
            autoClose: 5000,
        });
    },[error]);

    useEffect(() => {
        if (!campaign) return;
        setValue("code", campaign.code);
    }, [campaign, setValue]);

    useEffect(() => {
        const initialize = async () => {
            await loadAdCampaign(1);
        };
        initialize();
    }, [loadAdCampaign]);

    return (
        <div className="m-4">
            <div className="mb-4">
                <div className="flex flex-row justify-between">
                    <h1>Detalles de la campaña</h1>
                    <Button disabled={loading} isProcessing={loading} onClick={handleSubmit(save)}>Guardar campaña</Button>
                </div>
            </div>
            <Card>
                <div className="flex flex-col mb-2">
                    <Label className="mb-2">Código</Label>
                    <Textarea
                        placeholder="Escriba aquí"
                        {...register("code")}
                        helperText={errors && errors.code ? errors.code.message : ""}
                        required
                        color={errors && errors.code ? "failure" : "gray"}
                        rows={8}
                    />
                </div>
            </Card>
        </div>
    );
}

export default AdsCampaignPage;